const global = window

inputs.alias.tel = 'text'
inputs.alias.email = 'text'
inputs.alias.slug = 'text'
inputs.alias.permalink = 'text'
inputs.alias.link = 'text'
inputs.alias.url = 'text'

inputs.types.text = function (data, name, niceName, type, input, parent, inputWindow) {
    const aliases = ['email', 'ip'];
    if (input.attr('pattern') || aliases.includes(data.type)) {
        const mask = {
            placeholder: '',
            clearMaskOnLostFocus: true,
            placeholderChar: ' ',
            showMaskOnHover: false,
            jitMasking: true

        }
        if (aliases.includes(data.type)) {
            mask.alias = data.type;
        }
        else if (data.type == 'link') {
            mask.substitutes = {
                " ": "%20",
                "à": "a", "â": "a", "ä": "a", "á": "a", "å": "a", "ã": "a",
                "ç": "c",
                "è": "e", "é": "e", "ê": "e", "ë": "e",
                "í": "i", "î": "i", "ï": "i", "ì": "i",
                "ñ": "n",
                "ò": "o", "ó": "o", "ô": "o", "õ": "o", "ö": "o",
                "ù": "u", "ú": "u", "û": "u", "ü": "u",
                "ý": "y", "ÿ": "y",
                "À": "A", "Â": "A", "Ä": "A", "Á": "A", "Å": "A", "Ã": "A",
                "Ç": "C",
                "È": "E", "É": "E", "Ê": "E", "Ë": "E",
                "Í": "I", "Î": "I", "Ï": "I", "Ì": "I",
                "Ñ": "N",
                "Ò": "O", "Ó": "O", "Ô": "O", "Õ": "O", "Ö": "O",
                "Ù": "U", "Ú": "U", "Û": "U", "Ü": "U",
                "Ý": "Y", "Ÿ": "Y",
                "@": "-", "#": "-", "$": "-", "%": "-", "^": "-", "*": "-",
                "(": "-", ")": "-", "+": "-", "=": "-", "{": "-", "}": "-",
                "[": "-", "]": "-", "|": "-", "\\": "-", "/": "-", ":": "-",
                ";": "-", "\"": "-", "'": "-", "<": "-", ">": "-", ",": "-",
                "?": "-", "!": "-", "`": "-", "~": "-"
            }
        }
        else if (data.type == 'slug' || data.type == 'permalink') {
            mask.casing = "lower"
            mask.substitutes = {
                " ": '-', "&": '-', "@": '-', "#": '-', "$": '-', "%": '-', "^": '-',
                "*": '-', "(": '-', ")": '-', "+": '-', "=": '-', "{": '-', "}": '-',
                "[": '-', "]": '-', "|": '-', "\\": '-', "/": '-', ":": '-', ";": '-',
                "\"": '-', "'": '-', "<": '-', ">": '-', ",": '-', ".": '-', "?": '-',
                "!": '-', "`": '-', "~": '-',

                "à": 'a', "â": 'a', "ä": 'a', "á": 'a', "å": 'a', "ã": 'a',
                "ç": 'c',
                "è": 'e', "é": 'e', "ê": 'e', "ë": 'e',
                "í": 'i', "î": 'i', "ï": 'i', "ì": 'i',
                "ñ": 'n',
                "ò": 'o', "ó": 'o', "ô": 'o', "õ": 'o', "ö": 'o',
                "ù": 'u', "ú": 'u', "û": 'u', "ü": 'u',
                "ý": 'y', "ÿ": 'y',

                "À": 'A', "Â": 'A', "Ä": 'A', "Á": 'A', "Å": 'A', "Ã": 'A',
                "Ç": 'C',
                "È": 'E', "É": 'E', "Ê": 'E', "Ë": 'E',
                "Í": 'I', "Î": 'I', "Ï": 'I', "Ì": 'I',
                "Ñ": 'N',
                "Ò": 'O', "Ó": 'O', "Ô": 'O', "Õ": 'O', "Ö": 'O',
                "Ù": 'U', "Ú": 'U', "Û": 'U', "Ü": 'U',
                "Ý": 'Y', "Ÿ": 'Y'
            }
        }
        else {
            mask.regex = input.attr('pattern');
        }

        $(input).inputmask(mask);
    }
    let btnCopy = parent.find('.field__btn--copy');
    let btnOpen = parent.find('.field__btn--open');
    btnCopy.click(function() {
        let url = input.val();
        if (data.prefix) url = data.prefix+url;
        if (data.suffix) url = url+data.suffix;
        clipboardCopy(url);
    })
    btnOpen.click(function() {
        let url = input.val();
        if (data.prefix) url = data.prefix+url;
        if (data.suffix) url = url+data.suffix;
        window.open(url, "_blank");
    })
    if (btnCopy.length) {
        input.change(function() {
            if ($(this).val()) {
                btnCopy.show();
                if ($(this).val() == $(this).data('value')) {
                    btnOpen.show();
                }
                else {
                    btnOpen.hide();
                }
            }
            else {
                btnCopy.hide();
                btnOpen.hide();
            }
        })
        input.keyup(function() {
            input.change();
        })
        input.change();
    }
    return data
}
